module.exports = __webpack_public_path__ + "img/trash.d889ce60.svg";